import {deleteRequest, get, post, put} from '../utils/httpUtils';

const sortReducer = (previousValue, currentValue) => previousValue + currentValue.param + ':' + currentValue.ord + ',';


export const services = {
    getUsers: (body) => get(`users/?page=${body?.page}&size=${body?.size}&sort=${body?.orderBy}&email=${body?.search}`),
    getProviders: (body) => get(`providers/?page=${body?.page}&size=${body?.size
        }&sort=${['', ...body?.orderBy].reduce(sortReducer).slice(0, -1)||'name'
        }&name=${body?.searchTags?.name||''
        }&cuitOrCuil=${body?.searchTags?.cuitOrCuil||''
        }&email=${body?.searchTags?.email||''
        }&salesforceProviderName=${body?.searchTags?.salesforceProviderName||''
        }&salesforceBranchName=${body?.searchTags?.salesforceBranchName||''
    }`),
    getProvidersMe: (body) => get(`providers/me/branches?page=${body?.page}&size=${body?.size
        }&sort=${['', ...body?.orderBy].reduce(sortReducer).slice(0, -1)
        }&name=${body?.searchTags?.name||''
        }&cuitOrCuil=${body?.searchTags?.cuitOrCuil||''
        }&email=${body?.searchTags?.email||''
        }&salesforceProviderName=${body?.searchTags?.salesforceProviderName||''
        }&salesforceBranchName=${body?.searchTags?.salesforceBranchName||''
    }`),
    getStates: () => get('states'),
    getRegions: () => get('regions'),
    getBranches: () => get('salesforce/salesforceProviders/'),
    getBranchesProviders: (id) => get(`salesforce/branches/${id}`),
    addProvider: (body) => post('providers/' + body.type, body.user),
    putProvider: (body) => put('providers/' + body.id, body.user),
    deleteProvider: (id, providerType) => deleteRequest('providers/' + id),
    deleteAdmin: (id) => deleteRequest('users/delete-admin/' + id),
    addAdmin: (body) => post('users/admin', body),
    putAdmin: (body) => put('users/admin/', body.user),
    getSelfProvider: () => get(`providers/me`),
    getSelfAdmin: () => get(`users/me`),
    putChangePassword: (body) => put('users/change-password', body),
    getAffiliate: (document, documentType) => get(`affiliates/query/${documentType}?${documentType}=${document}`),
    getPlans: () => get('plans'),
    getMedicalServices: (plans, body) => get(`salesforce/medical-services?plans=${plans}&page=${body?.page}&size=${body?.size
        }&sort=${['', ...body?.orderBy].reduce(sortReducer).slice(0, -1)
        }&medicalServiceName=${body?.searchTags?.medicalServiceName||''
        }&medicalServiceCode=${body?.searchTags?.medicalServiceCode||''
        }&medicalServiceCategory=${body?.searchTags?.medicalServiceCategory||''
    }`),
    getAllMedicalServices: (body, branchId) => get(`salesforce/medical-services?plans=${body?.planName}&page=${body?.page}&size=${body?.size
        }&sort=${['', ...body?.orderBy].reduce(sortReducer).slice(0, -1)
        }&category=${body?.category||''
        }&medicalServiceName=${body?.searchTags?.medicalServiceName||''
        }&medicalServiceCode=${body?.searchTags?.medicalServiceCode||''
        }&medicalServiceCategory=${body?.searchTags?.medicalServiceCategory||''
        }&branchId=${branchId || ''}
    `),
    approveAttention: (body) => post('salesforce/approve-attention/', body),
    createAttention: (body) => post('salesforce/create-attention/', body),
    sendQuoteEmail: (body) => post('salesforce/send-quote-email/', body),
    getAllAttentions: (body) => get(`salesforce/attentions/?download=''&page=${body?.page}&size=${body?.size}&sort=${['', ...body?.orderBy].reduce(sortReducer).slice(0, -1)||'createdDate:desc'}&affiliateName=${body?.searchTags?.affiliateName||''}&affiliateLastName=${body?.searchTags?.affiliateLastName||''}&affiliateDocument=${body?.searchTags?.affiliateDocument||''}&planName=${body?.searchTags?.planName||''}&protocolCode=${body?.searchTags?.protocolCode||''}&medicalServiceCode=${body?.searchTags?.medicalServiceCode||''}&medicalServiceName=${body?.searchTags?.medicalServiceName||''}&providerAddress=${body?.searchTags?.providerAddress||''}&providerName=${body?.searchTags?.providerName||''}&dateFrom=${body?.searchTags?.dateFrom ? new Date(body?.searchTags?.dateFrom).toISOString() : ''}&dateTo=${body?.searchTags?.dateTo ? (() => {
            const date = new Date(body.searchTags.dateTo);
            date.setUTCHours(23, 59, 59, 999);
            return date.toISOString();
        })() : ''}&grouped=${body?.grouped || false}`),
    getAllAttentionsToDownload: (body) => get(`salesforce/attentions/?download='true'&page=${body?.page}&size=${body?.size}&sort=${['', ...body?.orderBy].reduce(sortReducer).slice(0, -1)||'createdDate:desc'}&affiliateName=${body?.searchTags?.affiliateName||''}&affiliateLastName=${body?.searchTags?.affiliateLastName||''}&affiliateDocument=${body?.searchTags?.affiliateDocument||''}&planName=${body?.searchTags?.planName||''}&protocolCode=${body?.searchTags?.protocolCode||''}&medicalServiceCode=${body?.searchTags?.medicalServiceCode||''}&medicalServiceName=${body?.searchTags?.medicalServiceName||''}&providerAddress=${body?.searchTags?.providerAddress||''}&providerName=${body?.searchTags?.providerName||''}&dateFrom=${body?.searchTags?.dateFrom ? new Date(body?.searchTags?.dateFrom).toISOString() : ''}&dateTo=${body?.searchTags?.dateTo ? (() => {
            const date = new Date(body.searchTags.dateTo);
            date.setUTCHours(23, 59, 59, 999);
            return date.toISOString();
        })() : ''}&grouped=${body?.grouped || false}`),
    deleteAttention: (body) => deleteRequest('salesforce/delete-attention/', body),
    bulkInsert: (body) => post('providers/bulk-insert/', body),
    getAmountList: (body)=> get(`amounts/?page=${body?.page}&providerName=${body?.providerName}`),
    getAmountListToDownload: (body) => get(`amounts/?download='true'&page=${body?.page}
    &sort='createdDate:desc&providerName=${body?.providerName}
    `),
    // [MODULE SERVICES] NEW SERVICE
};
